import React, { useState, useEffect, useContext } from 'react'
import DateService from 'live/services/date'
import Authorization from 'live/services/authorization'
import { TrippingAnnotationExtra } from '../types'
import api from '../../api'
import { __SOURCE_METADATA__ } from "../commom"
import { ContainerBody, Footer, FromDatePicker, Header, Selector, ToDatePicker, getUnixFromDateAndTime, getWellName, makeHisotry } from '../commom'
import { TRIPPING_TYPE_KEY, metadataOptionsKeyTitle } from './MetadataOptions'
import { DashboardContext } from 'live/context/dashboard'

const LOOKUP_KEY = 'options_tripping'

function makeExtra(form, wellName) {
    const extra: TrippingAnnotationExtra = {
        authorId: Authorization.user.id,
        author: Authorization.user.username,
        wellbore_name: wellName,
        [TRIPPING_TYPE_KEY]: form[TRIPPING_TYPE_KEY],
        metadata_type: TRIPPING_TYPE_KEY
    }

    return extra
}

export default function ({ mode = 'temporal', event, onHide, ...props }) {
    if (mode !== 'temporal')
        return

    const beginValue = DateService.getMoment(parseInt(event.begin))
    const endValue = event.end !== null && event.end !== undefined ? DateService.getMoment(parseInt(event.end)) : null
    const { state, params, ...context } = useContext(DashboardContext)
    const [errors, setErrors] = useState({})
    const [options, setOptions] = useState([])
    const [colors, setColors] = useState({})
    const [form, setForm] = useState({
        [TRIPPING_TYPE_KEY]: event?.extra?.[TRIPPING_TYPE_KEY],
        fromDate: beginValue,
        fromTime: beginValue.format('HH:mm:ss'),
        toDate: endValue ?? null,
        toTime: !!endValue ? endValue.format('HH:mm:ss') : null
    })
    const wellName = getWellName(params.filter)

    useEffect(() => {
        const controller = new AbortController()
        const signal = controller.signal
        api.getLookupTable(signal, LOOKUP_KEY).then(r => {
            setOptions(r.entries.map(({ key }) => ({ value: key, label: key })))
            setColors(r.entries.reduce((map, p) => {
                map[p.key] = p.value
                return map
            }, {}))
        })
    }, [])

    function onSubmit() {
        const payload = {
            ...event,
            extra: makeExtra(form, wellName),
            uid: (event && event.uid) || undefined,
            begin: getUnixFromDateAndTime(form.fromDate, form.fromTime),
            end: !!form.toDate && !!form.toTime ? getUnixFromDateAndTime(form.toDate, form.toTime) : null,
            __src: __SOURCE_METADATA__,
            __color: colors[form[TRIPPING_TYPE_KEY]],
            message: form[TRIPPING_TYPE_KEY],
            activeDashboardFilters: props.activeDashboardFilters,
        }

        payload['extra']['history'] = makeHisotry(event, payload)

        api.createAnnotation(payload).then(e => {
            onHide()
        })
    }

    return <ContainerBody>
        <div className="timeline__form">
            <Selector label={metadataOptionsKeyTitle[TRIPPING_TYPE_KEY]} property={TRIPPING_TYPE_KEY} options={options} form={form} setForm={setForm} />
            <FromDatePicker beginValue={beginValue} form={form} setForm={setForm} errors={errors} />
            <br />
            <ToDatePicker endValue={endValue} form={form} setForm={setForm} errors={errors} />
            <br />
            <br />
            <br />
            <br />
            <br />
            <Footer form={form} onSubmit={onSubmit} disabled={form[TRIPPING_TYPE_KEY] == null || options.length == 0} onHide={onHide} />
        </div>
    </ContainerBody>
}